module.exports = __webpack_public_path__ + "img/68.489a47f9.webp";